
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"54","height":"60","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"opacity":".1","d":"M53.22 27.813c-.21 5.437-1.563 9.77-4.063 13-2.5 3.229-5.834 4.843-10 4.843-1.709 0-3.22-.364-4.532-1.093a7.837 7.837 0 01-3.062-3.157c-2.042 2.75-4.781 4.125-8.219 4.125-2 0-3.75-.583-5.25-1.75-1.5-1.187-2.604-2.864-3.312-5.031-.688-2.167-.896-4.625-.625-7.375.625-5.208 2.302-9.396 5.03-12.563 2.73-3.166 6.074-4.75 10.032-4.75 3.063 0 5.698.709 7.906 2.126l1.97 1.312L37.5 35.844c-.354 2.896.646 4.343 3 4.343 1.771 0 3.25-1.124 4.438-3.374 1.208-2.271 1.875-5.167 2-8.688.354-6.958-1.094-12.333-4.344-16.125-3.23-3.792-7.969-5.688-14.219-5.688-3.979 0-7.52 1.021-10.625 3.063-3.083 2.02-5.53 4.896-7.343 8.625-1.792 3.708-2.802 7.938-3.032 12.688-.333 7.291 1.125 12.864 4.375 16.718 3.25 3.875 8.125 5.813 14.625 5.813 1.75 0 3.605-.209 5.563-.625 1.958-.396 3.552-.865 4.781-1.407l1.156 5.188c-1.27.833-2.99 1.5-5.156 2-2.146.52-4.302.781-6.469.781-5.687 0-10.5-1.093-14.437-3.281-3.917-2.167-6.833-5.385-8.75-9.656C1.146 41.948.292 36.77.5 30.687c.25-5.75 1.573-10.895 3.97-15.437 2.416-4.563 5.707-8.083 9.874-10.563C18.532 2.188 23.25.938 28.5.938s9.782 1.094 13.594 3.282c3.813 2.166 6.677 5.291 8.594 9.375 1.916 4.083 2.76 8.823 2.531 14.219zm-31.25 3.562c-.23 2.708-.022 4.76.624 6.156.667 1.375 1.73 2.063 3.188 2.063.979 0 1.875-.438 2.687-1.313.833-.875 1.52-2.125 2.063-3.75l1.25-14.25a7.49 7.49 0 00-1.938-.25c-2.333 0-4.135.917-5.406 2.75-1.25 1.813-2.073 4.677-2.469 8.594z","fill":"#8F7A61"}})])
          )
        }
      }
    